<template>
	<div class="dimencionamento">
		<div class="header">
			<b>Dimencionamento</b>
			<button
				@click="CriarPosto"
				class="btn btn-success pull-right btn-xs"
			>
				Novo posto
			</button>
		</div>
		<ul v-if="data.length > 0" class="list-dimencionamento">
			<li v-for="(item, id) in data" class="item-row">
				<div class="col-sm-7">
					<drop-draw
						v-model="item.funcao"
						placeholder="CARGO CBO"
						radio
						:asset="cbo"
						cod="value"
						title="value"
					/>
				</div>
				<div class="col-sm-2">
					<input
						type="number"
						placeholder="MASCULINO"
						v-model="item.masculino"
						class="form-control"
					/>
				</div>
				<div class="col-sm-2">
					<input
						type="number"
						placeholder="FEMININO"
						v-model="item.feminino"
						class="form-control"
					/>
				</div>
				<div class="col-sm-1">
					<button
						@click="RmoverPosto(id)"
						class="btn btn-danger btn-block"
					>
						<i class="fa fa-trash"></i>
					</button>
				</div>
				<div class="clearfix"></div>
			</li>
		</ul>
		<div v-else class="alert alert-warning" role="alert">
			<i class="fa fa-warning"></i> Nenhum posto definido
		</div>
	</div>
</template>
<script>
	import dropDraw from 'dropdraw';
	import CBO from 'js/cbo';
	import { ResetFuncao } from '../../../../../reset.js';
	import { clone } from 'lodash';

	export default {
		components: { dropDraw },
		props: ['funcoes'],
		data() {
			return {
				cbo: CBO,
				selectedCBOs: [],
			};
		},
		computed: {
			data() {
				return this.funcoes;
			},
		},
		methods: {
			CriarPosto() {
				this.data.push(clone(ResetFuncao));
			},
			RmoverPosto(id) {
				this.data.splice(id, 1);
			},
		},
	};
</script>
<style scoped>
	.header {
		padding-bottom: 15px;
	}
	.dimencionamento {
		margin-bottom: 15px;
	}
	.list-dimencionamento {
		padding: 0;
		list-style: none;
	}
	.list-dimencionamento .item-row {
		margin-bottom: 5px;
	}
	.list-dimencionamento .item-row > div {
		padding: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/sst/seguranca/components/dimencionamento/components/itemSetor/components/Dimencionamento.vue